var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step3"},[_c('i',{staticClass:"iconfont icon-wancheng"}),_c('span',[_vm._v("完成，请用新密码登录系统")]),_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.countdown)+"秒后自动跳转")])])}
var staticRenderFns = []

export { render, staticRenderFns }